// utils/sm4Util.js
const SM4 = require("gm-crypt").sm4;

// ！！！！！！！！！！ 重要：以下参数必须与后端完全一致 ！！！！！！！！！！ 
const COMMON_KEY = "swax2024llklwwrz"; // 双方约定的密钥 (16字节字符串)
const IV_FOR_CBC = "0000000000000000"; // CBC模式专用的初始化向量 (16字节)

// 1. ECB 模式配置 (无需IV)
const ecbConfig = {
    key: COMMON_KEY,
    mode: 'ecb',
    cipherType: 'base64'
};

// 2. CBC 模式配置 (需要IV)
const cbcConfig = {
    key: COMMON_KEY,
    mode: 'cbc',
    iv: IV_FOR_CBC,
    cipherType: 'base64'
};

// 创建两种模式的加密器实例
export const sm4Ecb = new SM4(ecbConfig);
export const sm4Cbc = new SM4(cbcConfig);

// 封装为便捷函数（以CBC模式为默认示例）
export function encrypt_cbc(text) {
    return sm4Cbc.encrypt(text, COMMON_KEY);
}
export function decrypt_cbc(text) {
    return sm4Cbc.decrypt(text, COMMON_KEY);
}
export function encrypt_ecb(text) {
    return sm4Ecb.encrypt(text, COMMON_KEY);
}
export function decrypt_ecb(text) {
    return sm4Ecb.decrypt(text, COMMON_KEY);
}